import { useRef } from 'react';
import { useFormikContext } from 'formik';

import {
  DialogBody,
  DialogSubClose,
  DialogSubHeader,
} from '@src/design-system/dialog';
import { MembersList } from '@shared/components/members-list';
import type { TSingleLeadFormValues } from '../helper';

const AssignToSubDialog = () => {
  const { setFieldValue, values } = useFormikContext<TSingleLeadFormValues>();
  const closeRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <DialogSubHeader>Assign To</DialogSubHeader>
      <DialogBody>
        <MembersList
          props={{
            infoItemProps: { withCheckbox: false },
            infiniteListProps: {
              props: {
                searchContainerProps: { className: 'p-0' },
                listContainerProps: { className: 'p-0' },
              },
            },
          }}
          onClickItem={(member, isSelected) => {
            setFieldValue('assignee', isSelected ? null : member.user);
            closeRef.current?.click();
          }}
          isItemSelected={(member) => {
            return String(values.assignee?.id) === String(member.user?.id);
          }}
        />
      </DialogBody>
      <DialogSubClose ref={closeRef} />
    </div>
  );
};

export default AssignToSubDialog;
